import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { brandRankingUrl, collectionsUrl } from "../../util/url";
import "./NavigationSubMenu.css";

/**
 * 홈 페이지 및 특정 페이지에서만 보이는 네비게이션 서브 메뉴 컴포넌트
 * 현재 경로에 따라 조건부로 렌더링됨
 */
export default function NavigationSubMenu() {
  const location = useLocation();

  const allowedPaths = [
    "/",
    "/collections",
    "/vintage-shops",
    "/brand-ranking",
  ];
  const shouldShowMenu = allowedPaths.some(
    (path) =>
      location.pathname === path || location.pathname.startsWith(`${path}/`),
  );

  if (!shouldShowMenu) {
    return null;
  }

  return (
    <div className="Navigation-submenu">
      <div className="container">
        <ul className="Navigation-submenu-list">
          <li className="Navigation-submenu-item">
            <NavLink
              to="/vintage-shops"
              className={({ isActive }) =>
                isActive
                  ? "Navigation-submenu-link active"
                  : "Navigation-submenu-link"
              }
            >
              빈티지샵
            </NavLink>
          </li>
          <li className="Navigation-submenu-item">
            <NavLink
              to={collectionsUrl()}
              className={({ isActive }) =>
                isActive
                  ? "Navigation-submenu-link active"
                  : "Navigation-submenu-link"
              }
            >
              기획전
            </NavLink>
          </li>
          <li className="Navigation-submenu-item">
            <NavLink
              to={brandRankingUrl()}
              className={({ isActive }) =>
                isActive
                  ? "Navigation-submenu-link active"
                  : "Navigation-submenu-link"
              }
            >
              브랜드 랭킹
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}
